import { defineStore } from 'pinia';
import { getCategoryList, getTagsList, getContentList } from '@/utils/api';

export const useStore = defineStore('main', {
  state: () => ({
    categories: [],
    currentCategoryId: '',
    companyInfo: [],
    allData: {}, // 用于存储所有 getData 的返回值
    loading: false,
    allTag: []
  }),
  actions: {
    async fetchCategories() {
      this.loading = true;

      try {
        const response = await getCategoryList();
        const dynamicRoutes = response?.rows.filter(v => v.categoryFlag === 'n' && v.categoryDisplay === 'enable')
          .sort((a, b) => a.categorySort - b.categorySort);

        this.categories = dynamicRoutes;

        // 拿所有的contentList
        const _allData = await Promise.allSettled(dynamicRoutes.map(async (route) => {
          const categoryId = route.id;
          const result = await this.getData(categoryId);
          const typeKey = route.categoryShortTitle; // 使用 route.categoryShortTitle 作为 key
          return { [typeKey]: result }; // 返回一个对象
        }));

        // 处理成功的结果
        const resolvedData = _allData.reduce((acc, { status, value }) => {
          if (status === 'fulfilled') {
            Object.assign(acc, value); // 合并成功的结果
          }
          return acc;
        }, {});

        this.allData = { ...this.allData, ...resolvedData }; // 合并更新 allData
        await this.getCompanyInfo(); // 公司信息
        await this.getTags(); // 文章标签

        const currentId = localStorage.getItem('currentCategoryId') || dynamicRoutes[0]?.id;
        localStorage.setItem('currentCategoryId', currentId);
      } catch (error) {
        console.error('获取动态路由失败:', error);
      }
      this.loading = false;
    },

    async getCompanyInfo() {
      try {
        const response = await getTagsList({ dictType: '公司信息' });
        const data = response?.rows.sort((a, b) => a.dictSort - b.dictSort) || [];
        this.companyInfo = data;
      } catch (error) {
        console.error('获取公司信息失败:', error);
      }
    },

    async getTags() {
      try {
        const response = await getTagsList({ dictType: '文章标签' });
        const data = response?.rows;
        if (data?.length) {
          this.allTag = data;
        }
        return [];
      } catch (error) {
        console.error('获取文章标签失败:', error);
      }
    },

    async getData(categoryId) {
      try {
        const response = await getContentList({ categoryId });
        return response.rows?.map(formatContent) || []; // 返回处理后的数据
      } catch (error) {
        console.error('获取数据失败:', error);
      }
    },
  },
});

// 格式化内容数据
function formatContent(v) {
  return {
    ...v,
    categoryId: v.categoryId,
    contentType: v.contentType || 'unknown',
    contentImg: v.contentImg ? JSON.parse(v.contentImg).map(img => `${process.env.VUE_APP_FILE_URL}${img.url}`) : [],
    contentTitle: v.contentTitle,
    id: v.id,
    contentTags: v.contentTags ? v.contentTags.split(',') : [],
    contentDetails: v.contentDetails,
    contentDatetime: v.contentDatetime,
  };
}

